import React from "react";
import PropTypes from "prop-types";

const ViewProfilePic = props => (
  <div className="view-profile-pic-container">
    <p>
      <a
        href={props.profileImg}
        target="_blank"
        className="download-btn"
        rel="noopener noreferrer"
      >
        <i className="fas fa-download"></i>
      </a>
      &nbsp;&nbsp;Download
    </p>
    <img className="profile-pic-lg" src={props.profileImg} alt="pic" />
  </div>
);

export default ViewProfilePic;

ViewProfilePic.prototype = {
  profileImg: PropTypes.string
};
